module.exports = function (app) {
  "use strict";
  app.controller("pages.home", [
    "$scope",
    "$state",
    "sessionData",
    "navigation",
    "modal",
    "coremetrics",
    "$filter",
    "planAdmin",
    "services",
    "$cookies",
    "storage",
    function (
      $scope,
      $state,
      sessionData,
      navigation,
      modal,
      coremetrics,
      $filter,
      planAdmin,
      services,
      $cookies,
      storage
    ) {
   var brands = ["hmbcbsde","highmarkbcbsde","de","6004","9011","9012","hmbcbswv","ms","highmarkbcbswv","mbh:wv","9009","6003", "9010",
      "hmbcbs","hbcbs","highmarkbcbs","6001","9001","hbs","pbs","hmbs","6002","highmarkblueshield","wv","hmny","neny","wny","9017","9018","6014"];
      
 if (brands.indexOf(sessionData.employerInfo.brandName) > -1) {
   services.eprsvc
     .challengeDisplayInfo()
     .enrollCheck(sessionData.basicInfo.loginId)
     .then(function (response) {
       var data = response.data;
       if (
         data &&
         data.challengeInfoList &&
         data.challengeInfoList.length > 0
       ) {
         localStorage.setItem("togglecheck", "false");
       } else {
         localStorage.setItem("togglecheck", "true");
       }
     });
 }
 // MFA Popup Removed for Aug Release//
//  if (brands.indexOf(sessionData.employerInfo.brandName) > -1 && sessionData.entitlements.clientStatus.cancelled == false)
//       {
//         var currentOtp;
//         var correlationId;
//         var validatePayload;
//         var generateCount = 0;

//         var obj = {
//           userId: sessionData.basicInfo.loginId,
//           appName: "employer",
//           deliveryChannel: "email",
//           email: sessionData.employerInfo.planAdministrator.email
//         };
//         var updateObj = {
//           oamAccessToken: $cookies.get("Oauth_access_token"),
//           hmhsmfaenrolled: "true",
//           hmhsmfaphone: " ",
//           hmhsmfaemail: sessionData.employerInfo.planAdministrator.email
//         }
//         var postBody = {
//           ltpaToken: $cookies.get("LtpaToken2"),
//           accessToken: $cookies.get("Oauth_access_token"),
//           brand: sessionData.employerInfo.planAdministrator.vendorName? sessionData.employerInfo.planAdministrator.vendorName.toLowerCase():"",
//         };
//         services.eprsvc
//           .challengeDisplayInfo()
//           .enrollCheck("employer", sessionData.basicInfo.loginId)
//           .then(function (response) {
//             var data = response.data;
//             if (
//               data &&
//               data.challengeInfoList &&
//               data.challengeInfoList.length > 0 
//             ) {
//               localStorage.setItem("togglecheck", "false");
//             } else {

//               localStorage.setItem("togglecheck", "true");
//               if (storage.get('showPopup')!=="false") {
//                 var modalInstance = modal.open({
//                   template: require("pages/multifactorLogin.html"),
//                   classes: "selected-groups-modal multifactor-large-modal",
//                   backdrop: "static",
//                  keyboard: false,
//                   scope: $scope,
//                 });
//                 $("*").not(".icon-caret-down").on('click', function (e) {
//                   if (!$(e.target).is(".icon-caret-down,.hmhs-icon,.multifactor-info-modal .ng-binding,.primary-header .ng-binding,.epr-find-employee .secondary-button-1")) {
//                     e.stopPropagation();
//                   }
//                 });
// 							}
//             }
//           });



//         $scope.title = "For Your Protection";
//         $scope.emailId = sessionData.employerInfo.planAdministrator.email;
//         $scope.enableDefault = true;
//         $scope.enableButton = true;
//         $scope.enableNo = false;
//         $scope.enableYes = false;
//         $scope.btnValue = "Enable";
//         $scope.enable = function () {
//           if ($scope.btnValue == "Enable") {
//             $scope.createOtp();
//             $scope.title = "Verify Passcode";
//             $scope.enableYes = true;
//             $scope.enableDefault = false;
//             $scope.btnValue = "Submit";
//           } else if ($scope.btnValue == "Close") {
//             $scope.closeModal();
//             $scope.setPopupStatus();
//           } else if ($scope.btnValue == "Submit") {
//             var verificationSec = angular.element(
//               document.getElementById("verificationVal")
//             );
//             $scope.textbox = verificationSec.val();
//             if ($scope.textbox === "") {
//               $scope.submitError = true;
//               $scope.IsHidden = true;
//               $scope.errorFlag = true;
//               generateCount++;
//               if (generateCount === 3) {
//                 $scope.generateSec();
//               }
//             } else {
//               validatePayload = {
//                 userId: sessionData.basicInfo.loginId,
//                 appName: "test",
//                 correlationId: correlationId,
//                 otpCode: $scope.textbox,
//               };
//               services.eprsvc
//                 .validateOtp()
//                 .validatePin(validatePayload, $cookies.get("Oauth_access_token"))
//                 .then(
//                   function (response) {
//                     $scope.closeModal();
//                     storage.set('showPopup', 'false');
//                     $scope.enrollEmp();
//                   },
//                   function (error) {
//                     $scope.submitError = true;
//                     $scope.IsHidden = true;
//                     $scope.errorFlag = true;
//                     generateCount++;
//                     if (generateCount === 3) {
//                       $scope.generateSec();
//                     }
//                   }
//                 );
//             }
//           }
//         };

//         $scope.setPopupStatus = function(){
//           storage.set('showPopup', 'false');
//         }
//         $scope.enrollEmp = function () {
//           //fire Base token
        
//           services.eprsvc
//             .fireBaseToken()
//             .getTempToken(postBody)
//             .then(function (response) {

//               if (response) {
//                 services.eprsvc
//                   .fireBaseToken()
//                   .getFirebaseToken(response.data)
//                   .then(function (fireToken) {

//                     //update user details
//                     services.eprsvc
//                       .fireBaseToken()
//                       .updateUser(updateObj, fireToken.data.idToken)
//                       .then(function (finalData) {
//                         localStorage.setItem("togglecheck", "false");
//                       },
//                         function (error) {
//                           localStorage.setItem("togglecheck", "true");
//                         }
//                       );

//                   });
//               }
//             });
//         }
//         $scope.generateSec = function () {
//           generateCount = 0;
//           $scope.submitError = false;
//           $scope.IsHidden = false;
//           $scope.errorFlag = false;
//           $scope.enableYes = false;
//           $scope.enableButton = false;
//           $scope.codeError = true;
//           $scope.generateYes = true;
//           $scope.newCodeVal = "Generate New Verification Code";
//           $scope.cancelBtnValue = "Cancel my MFA Enrollment";
//           $scope.helpYes = true;
//           $scope.notCommonhelpYes = false;
//         };
//         $scope.createOtp = function () {
//           services.eprsvc
//             .createOtp()
//             .generateOtp(obj, $cookies.get("Oauth_access_token"))
//             .then(function (response) {
//               currentOtp = response.data.minorCode;
//               correlationId = response.data.correlationId;
//               generateCount = 0;
//             });
//         };
//         $scope.noThankYou = function () {
//           $scope.enableNo = true;
//           $scope.enableDefault = false;
//           $scope.btnValue = "Close";
//         };
//         $scope.needHelp = function () {
//           $scope.title = "Multi-Factor Authentication (MFA) Support";
//           $scope.helpYes = true;
//           $scope.notCommonhelpYes = true;
//           $scope.enableYes = false;
//           $scope.enableButton = false;
//           $scope.submitError = false;
//           $scope.cancelBtnValue = "Cancel my MFA Enrollment";
//         };
//         $scope.cancelPopup = function () {
//           $scope.closeModal();
//           $scope.setPopupStatus();
//         };
//         $scope.newCode = function () {
//           $scope.enableYes = true;
//           $scope.enableButton = true;
//           $scope.btnValue = "Submit";
//           $scope.codeError = false;
//           $scope.generateYes = false;
//           $scope.helpYes = false;
//           $scope.createOtp();
//         };
//       }
 // MFA Popup Removed//
      if (
        !(
          sessionData &&
          sessionData.employerInfo &&
          sessionData.employerInfo.planAdministrator
        )
      ) {
        return;
      }

      // if (sessionData.basicInfo.role.toLowerCase() === "mcu_admin") {
      //     // navigation.setFilter("clientSelectionUser", function (item) {  //jshint ignore line
      //     //     //If link has entitlement property
      //     //     if (item.filterData && item.filterData.entitlement) {
      //     //         if (item.filterData.entitlement === '*') {
      //     //             return true;
      //     //         }
      //     //         return eval(item.filterData.entitlement); // jshint ignore:line
      //     //     }
      //     //     return true;
      //     // });
      //     // console.log("navaigation.dta",navigation.data);
      //     // navigation.addTempFilterToModules(["userTabs"], "clientSelectionUser");
      //     // navigation.update();
      //     $scope.clientNumber = sessionData.employerInfo.planAdministrator.clientNumber;
      //     var planAdministrator = sessionData.employerInfo.planAdministrator;
      //     $scope.username = planAdministrator.firstName + ' ' + planAdministrator.lastName;
      //     $scope.company = planAdministrator.company;
      //     $scope.quickLinks = navigation.data.quickLinks || [];
      //
      // }
      // else {
      if (
        sessionData.entitlements.clientStatus.cancelled == true &&
        !sessionData.cancelledClientHasAgreed
      ) {
        $state.go("cancelledConditions");
      }

      var planAdministrator = sessionData.employerInfo.planAdministrator;
      $scope.username =
        planAdministrator.firstName + " " + planAdministrator.lastName;
      $scope.company = planAdministrator.company;
      var dateStart = new Date(
        sessionData.entitlements.clientQualifiers.spendingAccountBlackOutStartDate
      );
      var dateEnd = new Date(
        sessionData.entitlements.clientQualifiers.spendingAccountBlackOutEndDate
      );
      $scope.objSpa = {
        paHasClaimsView: planAdmin.hasAnySpendingView(),
        spendingAccount:
          sessionData.entitlements.clientQualifiers.spendingAccount,
        spendingAccountBlackedOut:
          sessionData.entitlements.clientQualifiers.spendingAccountBlackedOut,
        spendingAccountPreBlackedOut:
          sessionData.entitlements.clientQualifiers
            .spendingAccountPreBlackedOut,
        startDate: $filter("date")(
          new Date(dateStart.setDate(dateStart.getDate() + 1)),
          "MM/dd/yyyy"
        ),
        endDate: $filter("date")(
          new Date(dateEnd.setDate(dateEnd.getDate() + 1)),
          "MM/dd/yyyy"
        ),
        restartDate: $filter("date")(
          new Date(dateEnd.setDate(dateEnd.getDate() + 1)),
          "MM/dd/yyyy"
        ),
      };

      if (sessionData.appConfig && sessionData.appConfig.ALERTS) {
        $scope.hasALERTS = sessionData.appConfig.ALERTS.booleanValue;
      }
      $scope.entitlements = sessionData.entitlements;

      $scope.fireCmElement = function (cm) {
        if (cm.elementId == "QUICK LINKS ADD EMPLOYEE") {
          coremetrics.startConversion(
            "EMPLOYERS:ENROLLMENT:ADD EMPLOYEE:QUICK LINK",
            "EMPLOYERS:ENROLLMENT"
          );
        }
        coremetrics.elementTag(cm.elementId, cm.theCategory);
      };

      $scope.quickLinks = navigation.data.quickLinks || [];

      $scope.navigation = navigation.data;
      (function setProviderUrl() {
        var providerLink;
        for (var i = 0; i < navigation.data.providers.length; ++i) {
          var id = navigation.data.providers[i].id;
          if (
            id === "findAProviderLink_ibc" ||
            id === "findAProviderLink_ahnj"
          ) {
            navigation.data.providers[i].configure(
              sessionData.employerInfo.planAdministrator.clientNumber
            );
            break;
          }
          $scope[id] = navigation.data.providers[i];
        }
      })();
      $scope.clientNumber =
        sessionData.employerInfo.planAdministrator.clientNumber;

      $scope.hasManyLinks = $scope.quickLinks.length > 5;
      $scope.hasWideLinks = $scope.quickLinks.some(function (link) {
        return link.label.length > 19;
      });

      $scope.resources = [
        {
          heading: "Training/FAQs",
          image: "/etc/designs/eprweb/app/resources/images/espots/question.png",
          text: "Learn how to use the Employer Portal to complete your Group Administration work.",
          linkText: "Get Employer Portal Training",
          linkHref: "home",
        },
        {
          heading: "Find a Provider",
          image: "/etc/designs/eprweb/app/resources/images/espots/usermd.png",
          text: "Help your employees find an in-network provider in their area.",
          linkText: "Find a Provider Now",
          linkHref: "home",
        },
        {
          heading: "Glossary of Health Coverage",
          image: "/etc/designs/eprweb/app/resources/images/espots/medkit.png",
          text: "This glossary helps make sense of health care with easy to understand definitions.",
          linkText: "Learn Your Health Care ABCs",
          linkHref: "home",
        },
        {
          heading: "Stay Smart About Benefits",
          image:
            "/etc/designs/eprweb/app/resources/images/espots/lightbulb.png",
          text: "Access insights and articles that will help you and your employees manage your health care and your costs.",
          linkText: "Stay Smart About Benefits",
          linkHref: "home",
        },
        {
          heading: "Communications Toolkit",
          image: "/etc/designs/eprweb/app/resources/images/espots/comment.png",
          text: "This kit contains everything you need to help your employees be more informed and make smart health care choices.",
          linkText: "Start Communicating",
          linkHref: "home",
        },
        {
          heading: "Second Opinion",
          image:
            "/etc/designs/eprweb/app/resources/images/espots/heartbeat.png",
          text: "Watch as specialists grapple with diagnosis and treatment options. Intriguing real-life cases keep you up-to-date on new medical information.",
          linkText: "Find Out More About Second Opinion",
          linkHref: "home",
        },
      ];
    },
  ]);

  return [
    {
      state: "home",
      url: "/home",
      postPassword: true,
      views: {
        "body@": {
          template:
            bootstrap.templates["page-templates/hmhs/landing-page.html"],
          controller: "pages.home",
        },
        "dashboard@home": {
          templateUrl: "home.employerTemplate.html/pages/home/home",
        },
      },
    },
    {
      state: "css",
      url: "/css",
      views: {
        "body@": {
          template:
            bootstrap.templates["page-templates/hmhs/landing-page.html"],
        },
        "dashboard@css": {
          templateUrl: "home.employerTemplate.html/pages/home/css",
        },
      },
    },
  ];
};
